import { useState } from 'react'
import { Card, Tag, Button, Input, List, Space, message, Tabs, ColorPicker } from 'antd'
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons'
import { entityTypes, relationTypes, topicTypes, positionTypes } from '../../utils/graphConstants'

const { TabPane } = Tabs

const TagConfig = () => {
  const [activeTab, setActiveTab] = useState('topic')

  const renderTagList = (items: any[], type: string) => (
    <List
      grid={{ gutter: 16, column: 2 }}
      dataSource={items}
      renderItem={(item) => (
        <List.Item>
          <Card className="w-full">
            <div className="flex items-center justify-between">
              <Space>
                {type === 'entity' && <span className="text-lg">{item.icon}</span>}
                <Tag color={item.color}>{item.label}</Tag>
                <span className="text-xs text-gray-400">{item.value}</span>
              </Space>
              <Space>
                <Button type="text" icon={<EditOutlined />} />
                <Button type="text" danger icon={<DeleteOutlined />} />
              </Space>
            </div>
            {type === 'relation' && (
              <div className="mt-2 text-xs text-gray-500">
                {item.description}
              </div>
            )}
          </Card>
        </List.Item>
      )}
    />
  )

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold">🏷️ 标签配置</h1>
        <Button type="primary" icon={<PlusOutlined />}>
          添加自定义标签
        </Button>
      </div>

      <Card>
        <Tabs activeKey={activeTab} onChange={setActiveTab}>
          <TabPane tab="质疑类型" key="topic">
            <div className="mb-4">
              <h3 className="text-lg font-medium mb-2">质疑类型标签</h3>
              <p className="text-gray-500">用于分类质疑事项的主题类型</p>
            </div>
            {renderTagList(topicTypes, 'topic')}
          </TabPane>

          <TabPane tab="结论标签" key="position">
            <div className="mb-4">
              <h3 className="text-lg font-medium mb-2">结论分类标签</h3>
              <p className="text-gray-500">用于标记答复方的处理结论</p>
            </div>
            {renderTagList(positionTypes, 'position')}
          </TabPane>

          <TabPane tab="NER实体类型" key="entity">
            <div className="mb-4">
              <h3 className="text-lg font-medium mb-2">NER实体类型 (15种)</h3>
              <p className="text-gray-500">命名实体识别的标签体系</p>
            </div>
            {renderTagList(entityTypes, 'entity')}
          </TabPane>

          <TabPane tab="关系类型" key="relation">
            <div className="mb-4">
              <h3 className="text-lg font-medium mb-2">实体关系类型 (7种)</h3>
              <p className="text-gray-500">知识图谱中的关系定义</p>
            </div>
            {renderTagList(relationTypes, 'relation')}
          </TabPane>
        </Tabs>
      </Card>
    </div>
  )
}

export default TagConfig
